import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  uploadFile(FormData: any, numero: any, usernameTarget?: string) {
    const username = usernameTarget || localStorage.getItem('usernameThatUserIsNowConnect2345789');
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return this.http.post(this.host + "/images/user/upload/uploadFile/" + username + "/" + numero, FormData, { headers: new HttpHeaders({ 'Authorization': token }) });
  }
}
